import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import Hidden from "@material-ui/core/Hidden";
import { Theme } from "@material-ui/core/styles";
import { Routes } from "../../../constants/routes";
import FormLink from "../../../components/FormLink";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import { registerSchoolFormValidator } from "../utils/validators/registerForm";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RegisterSchoolForm from "./forms/RegisterSchoolForm";
import { texts } from "../constants/texts";
import { useWizard } from "../../wizard/context";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    marginTop: 40,
  },
}));

export default function RegisterSchoolWidget() {
  const {
    actions: { register },
  } = useAuth();

  const { openWizard } = useWizard();

  const openModal = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "OOPS.",
          },
          content: texts.warningMessage,
        },
      ],
      submitButtonText: "Ok",
      cancelButtonText: null,
    });
  };

  const classes = useStyles();

  function _submit(data) {
    const errors = registerSchoolFormValidator(data, openModal);

    if (
      Object.keys(errors).length > 1 ||
      Object.keys(errors.schoolProfile.school).length
    ) {
      return errors;
    }

    return register(data, 3);
  }

  return (
    <>
      <Form onSubmit={_submit} component={RegisterSchoolForm} />

      <Hidden mdUp>
        <div className={classes.footer}>
          <TextDivider text={"OR"} />
          <Typography component="p" align="center">
            Already Registered?{" "}
            <FormLink to={`/${Routes.LOGIN}`}>Sign In</FormLink>
          </Typography>
        </div>
      </Hidden>
    </>
  );
}
